import { render } from "./GlossaryUsageLinkCard.vue?vue&type=template&id=340fb9ad&scoped=true&ts=true"
import script from "./GlossaryUsageLinkCard.vue?vue&type=script&lang=ts"
export * from "./GlossaryUsageLinkCard.vue?vue&type=script&lang=ts"

import "./GlossaryUsageLinkCard.vue?vue&type=style&index=0&id=340fb9ad&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340fb9ad"]])

export default __exports__